<div class="list-set" [class.list-set_fullscreen]="fullscreen">
    <h2 class="list-set--title">{{title}}</h2>
    <input
        class="list-set--filter"
        *ngIf="showFilter && rowData.length > 4"
        (keyup)="handleOnKeyup($event)"
        placeholder="Filtrar por nombre o número de productor"
    >
    <div class="list-set--items sc-scroll-bar">
        <div *ngFor="let row of filteredRowData; let index = index; let last = last" [ngClass]="{'list-row': true, 'disabled': row.disabled}"
             [class.last]="last">
            <div [@slideHorizontal]="{value: (runAnimation?'in':'out'), params:{delay:(50*index)+150}}"
                 (click)="handleClick(row, index)">
                <ng-template [ngTemplateOutlet]="template"
                             [ngTemplateOutletContext]="{ row: row, index: index }"></ng-template>
            </div>
        </div>
    </div>
</div>
